import React from "react";
import PropTypes from "prop-types";
import '../css/App.css';
import BlackJack from "./Books/BlackJack";
import Mortimer from "./Books/Mortimer";
import LongTom from "./Books/LongTom";
import Conductor from "./Books/Conductor";
import Pharaoh from "./Books/Pharaoh";
import RageInTheHeavens from "./Books/RageInTheHeavens";
import UponThisWorldOfStone from "./Books/UponThisWorldOfStone";
import DarknessAscending from "./Books/DarknessAscending";
import PaladinsDaughter from "./Books/PaladinsDaughter";
import WizardsHeir from "./Books/WizardsHeir";
import HeavensWarrior from "./Books/HeavensWarrior";

export default class AboutBookSection extends React.Component {
    static propTypes = {
        shownBook: PropTypes.string
    };

  render() {
    return (
        <div>
        {
            this.props.shownBook === "blackjack" ? <BlackJack />
            : this.props.shownBook === "mortimer" ? <Mortimer />
            : this.props.shownBook === "longtom" ? <LongTom />
            : this.props.shownBook === "conductor" ? <Conductor />
            : this.props.shownBook === "pharaoh" ? <Pharaoh />
            : this.props.shownBook === "rage" ? <RageInTheHeavens />
            : this.props.shownBook === "upon" ? <UponThisWorldOfStone />
            : this.props.shownBook === "darknesss" ? <DarknessAscending />
            : this.props.shownBook === "daughter" ? <PaladinsDaughter />
            : this.props.shownBook === "heir" ? <WizardsHeir />
            : this.props.shownBook === "warrior" ? <HeavensWarrior />

            : <div>
                <div class="text-divider text-divider-with-margin">Complete Works</div>
                <div id="all-books-list">
                    <div className="all-books-list-inner">
                        <div className="all-books-list-float">
                            <ul>
                                <span className="all-books-list-subtitle">The Darius Saga: The Paladin Trilogy</span>
                                <li>A Rage in the Heavens</li>
                                <li>Upon This World of Stone</li>
                                <li>Darkness Ascending</li>
                                <span className="all-books-list-subtitle">The Darius Saga: The Gorgorin Wars</span>
                                <li>Paladin's Daughter</li>
                                <li>Wizard's Heir</li>
                                <li>Heaven's Warrior</li>
                                <span className="all-books-list-subtitle">Behind the World Series</span>
                                <li>Black Jack: Behind the Waves</li>
                                <li>Mortimer: Behind the Walls</li>
                                <li>Long Tom: Behind the Woods</li>
                                <span className="all-books-list-subtitle">Other Works</span>
                                <li>The Conductor</li>
                                <li>Pharaoh's Mountain</li>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>
        }
        

</div>

   
    )}
}

